export default {
  Welcome: 'خوش آمدید',
  WelcomeToYourDashboard: 'به پیشخوان @:branding.AppName خوش آمدید.'
}
